import { appConstantSettings } from 'srcReact/appConstantSettings'

const datas = (t, countryCode) => {
  return [
    [
      {
        type: 'headerLeft',
        value: t('billing.pricing.tableComparison.findTheRightPlan')
      },
      { type: 'header', value: t('billing.pricing.essentialFree') },
      { type: 'header', value: t('billing.pricing.essential') },
      { type: 'header', value: t('billing.pricing.pro') },
      { type: 'header', value: t('billing.pricing.enterprise') }
    ],
    // [
    //   {
    //     type: 'groupCategory',
    //     value: t('billing.pricing.tableComparison.growth&Traction')
    //   },
    //   {
    //     type: 'subHeader',
    //     value: t('billing.pricing.free')
    //   },
    //   {
    //     type: 'subHeader',
    //     value: t('billing.pricing.perUserYearly', {
    //       amount: countryCode === 'EUR' ? appConstantSettings.EU_YEARLY_ESSENTIAL : appConstantSettings.YEARLY_ESSENTIAL
    //     })
    //   },
    //   {
    //     type: 'subHeader',
    //     value: t('billing.pricing.perUserYearly', {
    //       amount: countryCode === 'EUR' ? appConstantSettings.EU_YEARLY_PRO : appConstantSettings.YEARLY_PRO
    //     })
    //   },
    //   {
    //     type: 'subHeader',
    //     value: t('billing.pricing.custom')
    //   }
    // ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.numberOfUsers')
      },
      {
        type: 'normal',
        value: '25'
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.storagePerActiveWP')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: '10 GB'
      },
      {
        type: 'normal',
        value: '20 GB'
      },
      {
        type: 'normal',
        value: t('billing.pricing.custom')
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.maxStoragePerOrganization')
      },
      {
        type: 'normal',
        value: '5 GB'
      },
      {
        type: 'normal',
        value: t('billing.pricing.scalable')
      },
      {
        type: 'normal',
        value: t('billing.pricing.scalable')
      },
      {
        type: 'normal',
        value: t('billing.pricing.custom')
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.personalisedDynamicWidget')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.iOS&AndroidNativeApps')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.mobileNativePushNotifications')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.desktop&MobileOptimizedWebapp')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'groupCategory',
        value: t('billing.pricing.tableComparison.communityBuilding')
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.numberOfGroups')
      },
      {
        type: 'normal',
        value: t('billing.pricing.upTo', { count: 10 })
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.group&MixrMemberLimit')
      },
      {
        type: 'normal',
        value: t('billing.pricing.upTo', { count: 25 })
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.numberOfWorkplaces')
      },
      {
        type: 'normal',
        value: '1'
      },
      {
        type: 'normal',
        value: '2'
      },
      {
        type: 'normal',
        value: '5'
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.numberOfMixrs')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      },
      {
        type: 'normal',
        value: t('billing.pricing.unlimited')
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.userCurated')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.interestBased')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.groupCalendar')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.personalisedMemberProfile')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'groupCategory',
        value: t('billing.pricing.tableComparison.dashboards&Analytics')
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.workplaceDashboard')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.advancedInterestInsights')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.groupDashboard')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'groupCategory',
        value: t('billing.pricing.tableComparison.privateMessenger')
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.unlimitedOneOneConversations'),
        note: t('billing.pricing.tableComparison.storageLimitsApply')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.unlimitedGroupConversations'),
        note: t('billing.pricing.tableComparison.storageLimitsApply')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.unlimitedMessages'),
        note: t('billing.pricing.tableComparison.storageLimitsApply')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'groupCategory',
        value: t('billing.pricing.tableComparison.security&Privacy')
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.sAMLSSO')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.oneLogicRealTimeActiveDirectorySync')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'groupCategory',
        value: t('billing.pricing.tableComparison.support')
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      },
      {
        type: 'normal'
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.customCommunityArchitecture')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.onlineOnboarding')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: t('billing.pricing.days30')
      },
      {
        type: 'normal',
        value: t('billing.pricing.custom')
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.premiumKnowledgeBase')
      },
      {
        type: 'normal',
        value: false
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      {
        type: 'category',
        value: t('billing.pricing.tableComparison.standardKnowledgeBase')
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      },
      {
        type: 'normal',
        value: true
      }
    ],
    [
      { type: 'bottom' },
      { type: 'bottomBordered' },
      { type: 'bottomBordered' },
      { type: 'bottomBordered' },
      { type: 'bottomBordered' }
    ]
  ]
}

export default datas
